import { Directive, ElementRef, Input, OnInit, Renderer2, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Directive({
    standalone: true,
    selector: '[badge]',
})
export class BadgeDirective implements OnInit {
    @Input('badge') public badgeText: string | SafeHtml = '';
    @Input() public badgeAdditionalClasses: string = '';

    public constructor(private el: ElementRef, private renderer: Renderer2, private sanitizer: DomSanitizer) {}

    public ngOnInit(): void {
        if (this.badgeText) {
            const labelElement = this.renderer.createElement('span');
            // const bypassBadgeText = this.sanitizer.bypassSecurityTrustHtml(this.badgeText);
            const sanitizedBadgeText = this.sanitizer.sanitize(SecurityContext.HTML, this.badgeText);
            this.renderer.setProperty(labelElement, 'innerHTML', sanitizedBadgeText);
            this.renderer.addClass(labelElement, 'badge');

            if (this.badgeAdditionalClasses) {
                this.badgeAdditionalClasses
                    .split(' ')
                    .forEach((className) =>
                        this.renderer.addClass(labelElement, className),
                    );
            }

            this.renderer.appendChild(this.el.nativeElement, labelElement);
        }
    }
}
